var _defs, _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetodikiLfkIReab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 42.777,
    height: 44.336,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 4.54 4.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil2{fill:#2e4c89;fill-rule:nonzero}.fil1,.fil11,.fil3{fill:#445ea0;fill-rule:nonzero}.fil11,.fil3{fill:#94c2ed}.fil11{fill:#c3ddf4}.fil10,.fil8,.fil9{fill:#d9eafc;fill-rule:nonzero}.fil8,.fil9{fill:#eef6ff}.fil8{fill:#fff}"))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2792301626800"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.29,
    cy: 2.45,
    r: 2.25,
    style: {
      fill: "#ffca51",
      fillRule: "nonzero"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.01 1.9V.6H.86C.66.6.49.77.49.97v.93h.52z",
    className: "fil1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.01.61H.86C.66.61.49.78.49.98v.93h.19V.98c0-.19.14-.35.33-.37z",
    className: "fil2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.88.61h-.16V4.2c.21-.18.39-.39.53-.63V.98c0-.2-.17-.37-.37-.37z",
    className: "fil1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.14.61v.18c0 .02-.01.06-.03.08l-.39.47c-.01.01-.01.01-.02.01s-.02 0-.02-.01l-.28-.3c-.01-.01-.02-.02-.04-.02-.01 0-.03.01-.04.02l-.28.3c-.01.01-.01.01-.02.01S2 1.35 2 1.34L1.61.87C1.6.85 1.58.82 1.58.79V.61h-.6v1.3h2.08c.05 0 .08.04.08.08v1.77h.59V.61h-.6z",
    className: "fil3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.15 3.86v.47c0 .05-.04.08-.08.08H1.18a2.245 2.245 0 0 0 2.57-.23v-.31h-.59z",
    style: {
      fill: "#293d7c",
      fillRule: "nonzero"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.11.54 2.84.38a.076.076 0 0 0-.05-.02v.23c0 .02-.02.05-.03.07l-.37.26c-.01.01-.02.01-.03.01-.01 0-.02 0-.03-.01L1.96.66C1.94.65 1.93.62 1.93.59V.36c-.02 0-.03.01-.04.02l-.27.16c-.02.01-.04.04-.04.07v.18c0 .03.01.06.03.08l.39.47c.02.02.04.02.06 0l.28-.3c.02-.02.05-.02.06 0l.28.3c.02.02.04.02.06 0l.39-.47c.02-.02.03-.06.03-.08V.61c0-.03-.02-.06-.04-.07z",
    className: "fil1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.79.87a.133.133 0 0 1-.03-.08V.61c0-.03.02-.06.04-.07l.13-.08v-.1c-.02 0-.03.01-.04.02l-.27.16c-.02.01-.04.04-.04.07v.18c0 .03.01.06.03.08l.39.47c.02.02.04.02.06 0l.07-.07-.33-.4z",
    className: "fil2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.14 3.64h.6v.32h-.6z",
    style: {
      fill: "#994334",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8.59c0 .03-.02.06-.04.07l-.37.26c-.02.01-.05.01-.07 0L1.95.66C1.93.65 1.91.61 1.91.59V.05c0-.03.02-.05.05-.05h.79c.03 0 .05.02.05.05v.54z",
    style: {
      fill: "#ffc987",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.16.66C2.14.65 2.12.61 2.12.59V.05c0-.03.02-.05.05-.05h-.2c-.03 0-.05.02-.05.05v.54c0 .03.02.06.04.07l.37.26c.02.01.05.01.07 0l.06-.05-.3-.22z",
    style: {
      fill: "#e5ad70",
      fillRule: "nonzero"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.36,
    cy: 1.33,
    r: 0.09,
    className: "fil8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.36,
    cy: 1.7,
    r: 0.09,
    className: "fil8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M.27 2.21c0-.03.02-.05.05-.05h2.52c.03 0 .05.02.05.05V4.1c0 .03-.02.05-.05.05H.32c-.03 0-.05-.02-.05-.05V2.21z",
    className: "fil2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.18 3.18h-.69c-.06 0-.11-.05-.11-.11s.05-.11.11-.11h.69c.06 0 .11.05.11.11s-.05.11-.11.11zM2.07 3.53h-.42c-.06 0-.11-.05-.11-.11s.05-.11.11-.11h.42c.06 0 .11.05.11.11s-.05.11-.11.11zM2.89 2.59h-.22v-.12h.22v-.23h-.22v-.09h-.32v.09h-.72c-.06 0-.11.05-.11.11s.05.11.11.11h.72v.12h-.86c-.06 0-.11.05-.11.11s.05.11.11.11h.86a.162.162 0 0 0 .32 0h.22v-.23z",
    className: "fil9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.57 3.06c0-.06.05-.11.11-.11h-.19c-.06 0-.11.05-.11.11s.05.11.11.11h.19c-.06 0-.11-.05-.11-.11zM1.72 3.41c0-.06.05-.11.11-.11h-.19c-.06 0-.11.05-.11.11s.05.11.11.11h.19c-.06 0-.11-.05-.11-.11zM1.63 2.47h.19c-.06 0-.11-.05-.11-.11s.05-.11.11-.11h-.19c-.06 0-.11.05-.11.11s.05.11.11.11zM1.57 2.71c0-.06.05-.11.11-.11h-.19c-.06 0-.11.05-.11.11s.05.11.11.11h.19c-.06 0-.11-.05-.11-.11z",
    className: "fil10"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52 3.35a.16.16 0 0 1-.11-.05.16.16 0 0 1-.05-.11c0-.04.02-.08.05-.11a.16.16 0 0 1 .11-.05c.04 0 .08.02.11.05.03.03.05.07.05.11 0 .04-.02.08-.05.11a.16.16 0 0 1-.11.05z",
    className: "fil9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3.3a.16.16 0 0 1-.05-.11c0-.04.02-.08.05-.11.02-.02.04-.03.07-.04-.02 0-.03-.01-.05-.01a.16.16 0 0 0-.11.05.16.16 0 0 0-.05.11c0 .04.02.08.05.11.03.03.07.05.11.05.02 0 .03 0 .05-.01-.02-.01-.05-.02-.07-.04z",
    className: "fil10"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.68 3.62v-.04c0-.09-.07-.16-.16-.16s-.16.07-.16.16v.04h-.63c-.31 0-.57.22-.62.52v.01h.38v-.01c.04-.09.13-.15.23-.15s.19.06.23.15v.01h.87c.03 0 .06-.03.06-.06v-.48h-.22z",
    className: "fil9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1.92 3.62h-.19c-.31 0-.57.22-.62.52v.01h.19v-.01c.05-.3.32-.52.62-.52z",
    className: "fil10"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M.56 2.15v.19c-.08.05-.12.14-.12.24 0 .09.04.17.11.22v1.16c-.06.05-.09.11-.1.19h.57a.352.352 0 0 0-.1-.19V2.8c.06-.05.1-.13.1-.22 0-.1-.05-.18-.12-.24v-.19H.58zm.2 1.75H.72V2.87h.04v1.04z",
    className: "fil9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M.64 3.96V2.8a.295.295 0 0 1-.11-.22c0-.1.05-.18.12-.24v-.19H.56v.19c-.08.05-.12.14-.12.24 0 .09.04.17.11.22v1.16c-.06.05-.09.11-.1.19h.09a.32.32 0 0 1 .1-.19z",
    className: "fil10"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.06 1.89H.09a.09.09 0 0 0-.09.09v2.34c0 .05.04.09.09.09h2.97c.05 0 .09-.04.09-.09V1.98a.09.09 0 0 0-.09-.09zM2.88 4.1c0 .03-.02.05-.05.05H.31c-.03 0-.05-.02-.05-.05V2.21c0-.03.02-.05.05-.05h2.52c.03 0 .05.02.05.05V4.1z",
    className: "fil11"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M.19 4.33V1.99c0-.05.04-.09.09-.09H.09a.09.09 0 0 0-.09.09v2.34c0 .05.04.09.09.09h.19a.09.09 0 0 1-.09-.09z",
    className: "fil3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08 2.21c0-.03-.02-.05-.05-.05h-.19c.03 0 .05.02.05.05V4.1c0 .03-.02.05-.05.05h.19c.03 0 .05-.02.05-.05V2.21z",
    className: "fil11"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01 3.3c-.04 0-.07-.03-.07-.07v-.15c0-.04.03-.07.07-.07.04 0 .07.03.07.07v.15c0 .04-.03.07-.07.07z",
    className: "fil3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetodikiLfkIReab);
export default __webpack_public_path__ + "static/media/metodiki-lfk-i-reab.b1f7f07595ae6d5481c87408354b39a0.svg";
export { ForwardRef as ReactComponent };